import { render } from "./CustomersBaseTable.vue?vue&type=template&id=2dbab4fa&scoped=true"
import script from "./CustomersBaseTable.vue?vue&type=script&lang=js"
export * from "./CustomersBaseTable.vue?vue&type=script&lang=js"

import "./CustomersBaseTable.vue?vue&type=style&index=0&id=2dbab4fa&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbab4fa"]])

export default __exports__